import React from "react";
import { observer } from "mobx-react-lite";

import "./SnackbarNotifications.scss";
import SnackbarNotification from "./SnackbarNotification";
import { snackbarNotificationsService } from "../../services/notifications/SnackbarNotificationsService";

export default observer(function SnackbarNotifications() {
  return (
    <div className="snackbar-notifications">
      {snackbarNotificationsService.snackbarNotifications.map((notification) => (
        <SnackbarNotification key={notification.identifier} {...notification} />
      ))}
    </div>
  );
});
